import React, { useEffect, useRef } from 'react';

export interface IRawHTMLProps {
    html: string,
}

const RawHTML: React.FC<IRawHTMLProps> = ({
          html,
      }) => {
    const divRef = useRef(null)

    // This trick will get stuff in script tags working.
    // Inspired by conversations at https://stackoverflow.com/questions/35614809/react-script-tag-not-working-when-inserted-using-dangerouslysetinnerhtml
    useEffect(() => {
        if ( !html ) return;

        if ( divRef.current ) {
            const slotHtml = document.createRange().createContextualFragment(html) // Create a 'tiny' document and parse the html string
            // @ts-ignore
            divRef.current.innerHTML = '' // Clear the container
            // @ts-ignore
            divRef.current.appendChild(slotHtml) // Append the new content
            // @ts-ignore
            divRef.current.replaceWith(...Array.from(divRef.current.childNodes)); // get rid of the wrapping div
        }
    }, [html])


    return html ? <div ref={divRef}/> : null;
}

export default RawHTML;
